export const DECISION_TYPE_CODE = {
  Sended: 0, // 0 - Отправлено
  Readed: 1, // 1 - Прочитано
  Accepted: 2, // 2 - Принято
  Rejected: 3, // 3 - Отклонено
  Passed: 4, // 4 - Пройдено
};
